import React, { useState, MouseEvent } from 'react';
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

type ActionsMenuProps = {
  onEdit?: (row: any) => void;
  onDelete?: (row: any) => void;
  onView?: (row: any) => void;
  onCopy?: (row: any) => void;
  row: any;
};

export const ActionsMenu: React.FC<ActionsMenuProps> = ({ onView, onEdit, onDelete, onCopy, row }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action: 'view' | 'edit' | 'delete' | 'copy') => {
    handleClose();
    if (action === 'view' && onView) {
      onView(row);
    } else if (action === 'edit' && onEdit) {
      onEdit(row);
    } else if (action === 'copy' && onCopy) {
      onCopy(row);
    } else if (action === 'delete' && onDelete) {
      onDelete(row);
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <IconButton
        onClick={handleClick}
        sx={{
          boxShadow: 'none',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
          },
        }}
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            boxShadow: 'none',
            borderRadius: '8px',
            backgroundColor: 'white',
            border: '1px solid rgba(0, 0, 0, 0.12)',
          },
        }}
      >
        {
          onView && <MenuItem
            onClick={() => handleAction('view')}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
              },
            }}
          >
            <Typography variant="body2" color="textPrimary">View</Typography>
          </MenuItem>
        }
        {
          onEdit && <MenuItem
            onClick={() => handleAction('edit')}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
              },
            }}
          >
            <Typography variant="body2" color="textPrimary">Edit</Typography>
          </MenuItem>
        }
          {
          onCopy && <MenuItem
            onClick={() => handleAction('copy')}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
              },
            }}
          >
            <Typography variant="body2" color="textPrimary">Copy</Typography>
          </MenuItem>
        }
        {
          onDelete && <MenuItem
            onClick={() => handleAction('delete')}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
              },
            }}
          >
            <Typography variant="body2" color="textPrimary">Delete</Typography>
          </MenuItem>
        }
      </Menu>
    </Box>
  );
};
